import React, { useState } from "react";
import { Eye, EyeOff } from "react-feather";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

const PasswordProtectedRoute = ({ children, password }) => {
  const { t } = useTranslation();
  const [inputPassword, setInputPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputPassword === password) {
      setIsAuthenticated(true);
      setError("");
    } else {
      setError(t("PasswordProtected.error"));
    }
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  if (isAuthenticated) {
    return (
      <>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        {children}
      </>
    );
  }

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-neutral-900">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="fixed top-4 right-4 z-20">
        <LanguageSwitcher className="min-w-[160px]" />
      </div>

      <form
        onSubmit={handleSubmit}
        className="bg-neutral-800 p-8 rounded-3xl shadow-lg w-80 flex flex-col items-center"
        style={{
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
        }}
      >
        <h2 className="text-2xl font-semibold mb-6 text-neutral-100">
          {t("PasswordProtected.title")}
        </h2>
        <div className="relative w-full mb-6">
          <input
            type={showPassword ? "text" : "password"}
            value={inputPassword}
            onChange={(e) => setInputPassword(e.target.value)}
            className="w-full p-3 border border-neutral-700 rounded-xl bg-neutral-900 text-neutral-100 placeholder-neutral-500 pr-12 text-lg"
            placeholder={t("PasswordProtected.placeholder")}
            autoFocus
            style={{
              WebkitAppearance: "none",
              MozAppearance: "none",
              appearance: "none",
            }}
          />
          <button
            type="button"
            onClick={toggleShowPassword}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-neutral-400 hover:text-neutral-300"
            tabIndex={-1}
            aria-label={
              showPassword
                ? t("PasswordProtected.hide")
                : t("PasswordProtected.show")
            }
            title={
              showPassword
                ? t("PasswordProtected.hide")
                : t("PasswordProtected.show")
            }
          >
            {showPassword ? <Eye size={24} /> : <EyeOff size={24} />}
          </button>
        </div>
        {error && (
          <div className="text-red-500 text-sm mb-4 text-center font-medium">
            {error}
          </div>
        )}
        <button
          type="submit"
          className="w-full bg-neutral-600 text-neutral-100 py-3 rounded-2xl hover:bg-neutral-700 transition font-semibold text-lg"
          style={{ WebkitTapHighlightColor: "transparent" }}
        >
          {t("PasswordProtected.signIn")}
        </button>
      </form>
    </div>
  );
};

export default PasswordProtectedRoute;
